module.exports = __webpack_public_path__ + "static/img/wu.b36a5cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wu.png
// module id = Kv1+
// module chunks = 1